import { Fragment, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import data from "@emoji-mart/data/sets/14/apple.json";
import { LANG_ARR_PRESENTATION } from "@lang";
import { init } from "emoji-mart";
import {
  ArrowTopDownIcon,
  ChevronDownIcon,
  GlobeIcon,
} from "@100mslive/react-icons";
import { Box, Dropdown, Text, Tooltip } from "@100mslive/roomkit-react";
import IconButton from "../IconButton";

init({ data });

export const SelectLanguage = () => {
  const [open, setOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState(() => {
    try {
      return localStorage.getItem("lang") || "";
    } catch (e) {
      return "";
    }
  });
  const { t, i18n } = useTranslation();

  const updateState = useCallback(
    code => {
      localStorage.setItem("lang", code);
      setSelectedLang(code);
      i18n.changeLanguage(code);
    },
    [i18n]
  );

  useEffect(() => {
    try {
      const stored = localStorage.getItem("lang");
      if (stored && i18n.language !== stored) {
        i18n.changeLanguage(stored);
        setSelectedLang(stored);
      }
    } catch (e) {}
  }, [i18n]);

  return (
    <Fragment>
      <Dropdown.Root open={open} onOpenChange={setOpen}>
        <Dropdown.Trigger asChild data-testid="emoji_reaction_btn">
          <IconButton
            css={{
              w: "auto",
              p: "$4",
              h: "auto",
            }}
          >
            <Text variant="sm" css={{ mx: "$4", c: "inherit" }}>
              {LANG_ARR_PRESENTATION.find(_ => _.code === selectedLang)
                ?.label || t("lbl_select_language")}
            </Text>
            <ChevronDownIcon />
          </IconButton>
        </Dropdown.Trigger>
        <Dropdown.Content
          sideOffset={5}
          align="center"
          css={{
            backgroundColor: "$surface_dim",
            maxHeight: "$96",
            width: "$38",
            "div[role='separator']:first-child": {
              display: "none",
            },
          }}
        >
          {LANG_ARR_PRESENTATION.map((lang, index) => {
            return (
              <Dropdown.Item
                key={index}
                css={{ "&:hover": { backgroundColor: "$surface_bright" } }}
                onClick={() => updateState(lang.code)}
              >
                <Text>{lang.label}</Text>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Content>
      </Dropdown.Root>
    </Fragment>
  );
};
